<template>
  <div>
    <landing-create :content="content"></landing-create>
    <list-component
      :service="service"
      :tableMetaData="tableMetaData"
    ></list-component>
  </div>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import ListComponent from '../../../components/ListComponent.vue';
import services from '../../../services';

const { controlPanelRegistry } = services;
const { logsService } = controlPanelRegistry;

export default {
  name: 'logsList',
  components: {
    ListComponent,
    LandingCreate,
  },
  data() {
    // const component = this;
    return {
      service: logsService,
      tableMetaData: {
        tableFilters: {
          selections: [],
          dates: [
            {
              text: 'Date created',
              column: 'dateCreated',
            },
            {
              text: 'Date updated',
              column: 'dateUpdated',
            },
          ],
        },
        tableHeaders: [
          {
            text: 'Email',
            value: 'email',
          },
          {
            text: 'Event Type',
            value: 'eventType',
          },
          {
            text: 'Status',
            value: 'status',
          },
          {
            text: 'IP Address',
            value: 'ipAddress',
          },
          {
            text: 'User Agent',
            value: 'userAgent',
          },
          {
            text: 'Location',
            value: 'location',
          },
          {
            text: 'Created',
            value: 'timestamp',
          },
        ],
        URLName: 'logs',
      },
      content: {
        pageTitle: 'Logs',
      },
    };
  },
};
</script>
